"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeSummaryDocument () {
        return EmployeeSummaryDocument;
    },
    get SamplingStrategySchema () {
        return SamplingStrategySchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const SamplingStrategySchema = _zod.z.enum([
    "first_n_recent",
    "stratified_time",
    "embedding_top_k"
]);
const EmployeeSummaryDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    timeframe: _zod.z.enum([
        "all",
        "12mo",
        "90d",
        "30d"
    ]),
    schema_version: _zod.z.literal(5),
    generated_at: _zod.z.date(),
    source_watermark: _zod.z.date(),
    prompt_hash: _zod.z.string(),
    llm_model: _zod.z.string(),
    llm_duration_ms: _zod.z.number(),
    llm_task_id: _zod.z.string().nullable(),
    llm_status: _zod.z.enum([
        "complete",
        "in_progress",
        "failed"
    ]),
    sampling_strategy: SamplingStrategySchema.optional(),
    // Why the sampler deviated (e.g. "no_embeddings_fallback"). Persisted so the
    // freshness gates can invalidate a fallback summary once the corpus is
    // backfilled — the watermark alone never moves on backfill.
    sampling_rejection_reason: _zod.z.string().nullable().optional(),
    // Authored content (the sandbox seeds): the freshness gates never regenerate over it.
    is_pinned: _zod.z.boolean().optional(),
    signal_counts: _zod.z.object({
        reviews: _zod.z.number(),
        feedback_received: _zod.z.number(),
        feedback_given: _zod.z.number(),
        goals: _zod.z.number(),
        meetings: _zod.z.number()
    }),
    reviews_stats: _zod.z.object({
        assigned: _zod.z.number(),
        forms_authored_for_others: _zod.z.number(),
        completed: _zod.z.number(),
        overdue: _zod.z.number(),
        last_review_date: _zod.z.date().nullable()
    }).nullable(),
    goals_stats: _zod.z.object({
        assigned: _zod.z.number(),
        completed: _zod.z.number(),
        overdue: _zod.z.number(),
        created: _zod.z.number(),
        avg_progress: _zod.z.number().nullable()
    }).nullable(),
    feedback_stats: _zod.z.object({
        unique_givers: _zod.z.number(),
        requested: _zod.z.number(),
        requested_response_rate: _zod.z.number().nullable(),
        avg_response_time_days: _zod.z.number().nullable()
    }).nullable(),
    meetings_stats: _zod.z.object({
        one_on_ones_with_manager: _zod.z.number(),
        action_items_complete: _zod.z.number(),
        action_items_incomplete: _zod.z.number(),
        avg_action_item_completion_days: _zod.z.number().nullable(),
        held_meetings: _zod.z.number(),
        participated_meetings: _zod.z.number(),
        participation_rate: _zod.z.number().nullable()
    }).nullable(),
    dumb_mode: _zod.z.boolean(),
    right_now: _zod.z.object({
        momentum: _zod.z.array(_zod.z.string()),
        watch_outs: _zod.z.array(_zod.z.string())
    }).nullable(),
    reviews_insights: _zod.z.object({
        strengths: _zod.z.array(_zod.z.string()),
        areas_of_opportunity: _zod.z.array(_zod.z.string()),
        goals_from_review_creation: _zod.z.array(_zod.z.string()),
        goals_from_review_discussions: _zod.z.array(_zod.z.string())
    }).nullable(),
    goals_insights: _zod.z.object({
        execution: _zod.z.array(_zod.z.string()),
        patterns_risks: _zod.z.array(_zod.z.string())
    }).nullable(),
    feedback_insights: _zod.z.object({
        patterns: _zod.z.array(_zod.z.string())
    }).nullable(),
    meetings_insights: _zod.z.object({
        patterns: _zod.z.array(_zod.z.string())
    }).nullable(),
    top_highlights: _zod.z.object({
        summary: _zod.z.string(),
        accomplishments: _zod.z.array(_zod.z.string()),
        areas_of_improvement: _zod.z.array(_zod.z.string())
    }).nullable(),
    coaching_recommendations: _zod.z.array(_zod.z.object({
        section: _zod.z.string(),
        suggestion: _zod.z.string()
    })).nullable(),
    section_narratives: _zod.z.object({
        competencies: _zod.z.string().nullable()
    }).nullable(),
    competencies: _zod.z.object({
        counts: _zod.z.object({
            meets: _zod.z.number(),
            exceeds: _zod.z.number(),
            below: _zod.z.number()
        }),
        company_wide: _zod.z.array(_zod.z.object({
            label: _zod.z.string(),
            current: _zod.z.number().nullable(),
            expected: _zod.z.number().nullable()
        })),
        role: _zod.z.array(_zod.z.object({
            label: _zod.z.string(),
            current: _zod.z.number().nullable(),
            expected: _zod.z.number().nullable()
        }))
    }).nullable()
});
